<template>
    <div class="card shadow-sm mb-5 p-5 card-flush overflow-hidden h-md-100">
      <button v-if="remove"
          type="button"
          class="btn-close position-absolute top-0 end-0 mt-2 me-4"
          aria-label="Remove"
          @click="remove"/>

        <div class="card-header">
        <div class="card-title">
            <h5 style="text-align: start">{{ title }}</h5>
        </div>
        
        </div>
        <Loader :is-loading="loading">
          <div class="card-body d-flex text-center justify-content-center flex-column px-0">
            <div v-show="!getTopActivitiesForWonOpportunities?.length" class="text-center">
              <img src="@/assets/media/pos/Empty2.png" alt="" class="mw-100 h-150px" />
              <div class="text-gray-400 fs-4 fw-bold">{{ $t('no_data_found') }}</div>
            </div>
            <div v-show="getTopActivitiesForWonOpportunities?.length" class="p-5">
              <canvas id="kt_chartjs_top_activities" class="mh-200px"></canvas>
            </div>
          </div>
        </Loader>
    </div>  
</template>
<script setup>
import Loader from '@/components/Loader.vue';
import { onMounted, shallowRef, ref, watch} from 'vue';
import { useStore } from 'vuex';

const store = useStore()

const props = defineProps({
  id:{type: String, required: true},
  title:{type: String, required: true},
  loading:{type: Boolean, default: false},
  loadStats:{type: Function, required: true},
  remove:{type: Function},
  start: { type: Date, required: false },
  end: { type: Date, required: false },

})
  
const query = ref({
    start_date: '',
    end_date: '',
    opportunity_id: '',
    seller_id: '',
    status: 'WON'
})

const row = ref(0)
const column = ref(0)
const getTopActivitiesForWonOpportunities = ref([])
const chartTopActivityRef = shallowRef(null)

watch(() => [props.start, props.end], () => {
 if(props.start) query.value.start_date = props.start
 if(props.end) query.value.end_date = props.end
})

watch(() => query.value, () => {
  if (query.value.start_date && query.value.end_date) {
    loadData();
  }
}, {deep: true})


function loadData(){
  if (!query.value.start_date || !query.value.end_date) {
    console.warn("Dates non définies, loadData ignorée");
    return;
  }
  
    Promise.all([
        props.loadStats({id:props.id,startDate: query.value.start_date, endDate: query.value.end_date, opportunity_id: query.value.opportunity_id, seller_id: query.value.seller_id, status: query.value.status}).then((res) => {
          let answer = res?.response?.data || res?.data
          row.value = res.row
          column.value = res.column

          getTopActivitiesForWonOpportunities.value = answer?.getTopActivitiesForWonOpportunities

        }),
        store.dispatch('pipelines/loadPipelines'),
        store.dispatch('pipelines/loadSalesPersons')
    ]).then(() => {
      chartTopActivity()
    })
}

function chartTopActivity() {
    let ctx = document.getElementById('kt_chartjs_top_activities');
    if (ctx) {
      ctx = ctx.getContext('2d')
      if(Chart.getChart("kt_chartjs_top_activities")) {
        Chart.getChart("kt_chartjs_top_activities")?.destroy()
      }
    }
    const data = []
    getTopActivitiesForWonOpportunities.value?.forEach(item => {
       data.push({
        name: item.type_activity,
        amount: item.count
       })
    })

    let config = {
      type: 'bar',
      data: {
        labels: data.map(item => item.name),
        datasets: [{
          label: i18n.global.t('crm.pipeline.activity.liste'),
          data: data.map(item => item.amount),
          backgroundColor: data.map(item => '#0072CE'),
          borderColor: data.map(item => '#0056A1'),
          borderRadius: 10,
          borderWidth: 1
        }]
      },
      options: {
        responsive: true,
        plugins: {
          tooltip: {
            callbacks: {
              label: function(context) {
                return `${context.label}: ${context.raw}`;
              }
            }
          }
        },
        scales: {
          x: {
            stacked: true,
            grid: {
              display: false
            }
          },
          y: {
            stacked: true,
            beginAtZero: true
          }
        }
      }
    };

    if (!chartTopActivityRef.value) {
      chartTopActivityRef.value = new Chart(ctx, config);
    }else{
      chartTopActivityRef.value.destroy()
      chartTopActivityRef.value = new Chart(ctx, config);
    }
  }

onMounted(() => {
 if(props.start) query.value.start_date = props.start
 if(props.end) query.value.end_date = props.end 
})
</script>